import React from 'react';
import { useOfferContext } from '../../../../context';
import { FeatureLabel } from '../../../../components/FeatureLabel';
import { Video16 } from '@cian/ui-kit';

export function VideoLabelContainer() {
  const { hasVideo } = useOfferContext();

  if (!hasVideo) {
    return null;
  }

  return <FeatureLabel icon={<Video16 color="white_100" />} title={'Объявление с видео'} />;
}
